<script setup>
import { useForm } from '@inertiajs/vue3';
import { useRoute } from '@/Utils/useRoute';

const route = useRoute();
const form = useForm({ email: '' });

function submit() {
    form.post(route('newsletter.subscribe'), {
        preserveScroll: true,
        onSuccess: () => form.reset('email'),
    });
}
</script>

<template>
    <div class="newsletter">
        <h4 class="newsletter-heading">Nyhedsbrev</h4>
        <p class="newsletter-tagline">Få de bedste tilbud direkte i din indbakke.</p>
        <form class="newsletter-form" @submit.prevent="submit">
            <input
                v-model="form.email"
                type="email"
                class="newsletter-input"
                placeholder="Din e-mail"
                required
                aria-label="E-mail til nyhedsbrev"
            />
            <button type="submit" class="newsletter-btn" :disabled="form.processing">Tilmeld</button>
        </form>
        <p v-if="form.recentlySuccessful" class="newsletter-msg ok">Tak — du er tilmeldt!</p>
        <p v-else-if="form.errors.email" class="newsletter-msg err">{{ form.errors.email }}</p>
    </div>
</template>

<style scoped>
.newsletter {
    margin-top: 20px;
    max-width: 320px;
}
/* Matcher .footer-heading i Footer.vue (scoped CSS krydser ikke komponent-grænser,
   så hierarkiet skal gendannes her — ellers falder h4 tilbage til browser-default). */
.newsletter-heading {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    color: var(--pc-text-muted);
    letter-spacing: 0.05em;
    margin: 0 0 8px 0;
}
.newsletter-tagline {
    color: var(--pc-text-secondary);
    font-size: 0.875rem;
    line-height: 1.5;
    margin: 0 0 10px 0;
}
.newsletter-form {
    display: flex;
    gap: 8px;
}
.newsletter-input {
    flex: 1;
    min-width: 0;
    padding: 9px 12px;
    border-radius: 8px;
    border: 1px solid var(--pc-border);
    background: var(--pc-bg-secondary);
    color: var(--pc-text-primary);
    font-size: 0.875rem;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.newsletter-input::placeholder {
    color: var(--pc-text-muted);
}
.newsletter-input:focus {
    outline: none;
    border-color: var(--pc-accent);
    box-shadow: 0 0 0 3px var(--pc-accent-glow);
}
.newsletter-btn {
    padding: 9px 16px;
    border-radius: 8px;
    border: none;
    background: var(--pc-accent);
    color: #04221b;
    font-weight: 600;
    font-size: 0.875rem;
    white-space: nowrap;
    cursor: pointer;
    transition: background 0.15s ease;
}
.newsletter-btn:hover:not(:disabled) {
    background: var(--pc-accent-hover);
}
.newsletter-btn:disabled {
    opacity: 0.6;
    cursor: default;
}
.newsletter-msg {
    margin: 8px 0 0;
    font-size: 0.8125rem;
}
.newsletter-msg.ok {
    color: var(--pc-success);
}
.newsletter-msg.err {
    color: #ef476f;
}
</style>
